import BaseService from '../BaseService.js'

export default class BewilligungService extends BaseService {
  constructor() {
    super('public/bewilligung')
  }

  async calculate(data) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(this.backendUrl, {
        method: 'POST',
        cache: 'reload',
        headers: this.getJsonHeader(),
        body: JSON.stringify(data)
      })
    )
  }

  async downloadPdf(data) {
    await this.retrieveBackendUrl()
    const response = await fetch(`${this.backendUrl}/pdf`, {
      method: 'POST',
      cache: 'reload',
      headers: this.getJsonHeader(),
      body: JSON.stringify(data)
    })

    if (!response.ok) {
      showAlert('Fehler', 'PDF konnte nicht erstellt werden', 'error')
      return
    }

    const blob = await response.blob()
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'ergebnis.pdf'
    link.click()
    URL.revokeObjectURL(url)
  }
}
